export default __webpack_public_path__ + "static/media/warehouse1.6fc6409d.png";